<template>
  <lazy-div :load="doInit">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-flex xs4>
              <div class="headline">Claim List</div>
            </v-flex>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-flex xs12>
            <v-expansion-panel expand :value="toogleArray">
              <v-expansion-panel-content>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xl3 lg6 xs6>
                          <v-text-field
                            v-model="filters.clmNo"
                            :label="labels.clmNo"
                            :error-messages="errors.collect('clmNo')"
                            data-vv-name="clmNo"
                            :data-vv-as="labels.clmNo"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg6 xs6>
                          <v-text-field
                            v-model="filters.polNo"
                            :label="labels.polNo"
                            :error-messages="errors.collect('polNo')"
                            data-vv-name="polNo"
                            :data-vv-as="labels.polNo"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg6 xs6>
                          <v-text-field
                            v-model="filters.insdName1"
                            :label="labels.insdName1"
                            :error-messages="errors.collect('insdName1')"
                            data-vv-name="insdName1"
                            :data-vv-as="labels.insdName1"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-data-table
            v-bind:headers="headers"
            v-bind:items="items"
            :server-items-length="totalItems"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="index"
            :loading="loading"
            :no-data-text="noDataText"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span v-on="on">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template v-slot:item="row">
              <tr>
                <td class="text-xs-left">{{ row.item.clmNo }}</td>
                <td class="text-xs-left">{{ row.item.polNo }}</td>
                <td class="text-xs-left">{{ row.item.endtCnt }}</td>
                <td class="text-xs-left">{{ row.item.renCnt }}</td>
                <td class="text-xs-left">{{ row.item.insdName1 }}</td>
                <td class="text-xs-left">{{ formatDate(row.item.lossDate) }}</td>
                <td class="text-xs-left">{{ row.item.vehRegNo }}</td>
                <td class="text-xs-left">{{ row.item.chasNo }}</td>
                <td class="text-xs-left">{{ row.item.vesName }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" query @query="doQuery" :loading="loading"></table-action>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </lazy-div>
</template>

<script>
import clone from 'clone'
import * as TableConst from '@/mixins/table'
import { mapGetters } from 'vuex'
import { expandURI, filterQuery } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { listMixin } from '@/components/reusable/listMixins'
export default {
  data() {
    return {
      headers: [
        { text: 'Claim', value: 'clmNo' },
        { text: 'Policy', value: 'polNo' },
        { text: 'Endt', value: 'endtCnt' },
        { text: 'Ren', value: 'renCnt' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Loss Date', value: 'lossDate' },
        { text: 'Vehicle', value: 'vehRegNo' },
        { text: 'Chasis No.', value: 'chasNo' },
        { text: 'Ves Name', value: 'vesName' },
        TableConst.tableActionHeader
      ],
      pagination: {
        sortBy: ['clmNo']
      },
      menu: [],
      filters: {
        clmNo: '',
        polNo: '',
        insdName1: ''
      },
      labels: {
        clmNo: 'Claim No.',
        polNo: 'Policy No.',
        insdName1: 'Insured Name'
      },
      totalItems: 0,
      toogleArray: [false]
    }
  },
  watch: {
    fetchClaim: function (value) {
      if (value !== false) {
        this.doInit()
      }
    },
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData()
    }
  },
  computed: {
    ...mapGetters(['checkAccess'])
  },
  methods: {
    async doInit() {
      this.fetchData()
    },
    async fetchData() {
      this.loading = true
      const apiURI = this.$store.state.adminInter.intermediary.menu.pagedClaimList
      if (apiURI) {
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            inter: this.inter,
            interGroupCode: this.interGroupCode
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), clone(this.filters), this.pagination.sortBy, this.pagination.sortDesc)
          )
          const { data } = result.data
          if (data) {
            this.totalItems = result.data.totalElements
            this.items = []
            data.map((claim) => {
              const convertClaim = {
                clmNo: claim.clmNo,
                polNo: claim.polNo,
                endtCnt: claim.endtCnt,
                renCnt: claim.renCnt,
                insdName1: claim.insdName1,
                lossDate: claim.lossDate,
                vehRegNo: claim.vehRegNo,
                chasNo: claim.chasNo,
                vesName: claim.vesName,
                clmStat: claim.clmStat
              }
              this.items.push(convertClaim)
            })
            this.loading = false
          } else {
            this.loading = false
            this.items = []
          }
        } catch (error) {
          const { data } = error
          if (data) {
            this.message(data)
            this.fieldMessage(data)
            this.loading = false
          }
        }
      } else {
        this.loading = false
      }
    },
    doClearFilters() {
      this.filters.clmNo = null
      this.filters.polNo = null
      this.filters.insdName1 = null
      this.fetchData()
    },
    doFilters() {
      this.resetMessages()
      // Reset to page 1
      this.pagination.page = 1
      this.fetchData()
    },
    doQuery(data) {
      this.loading = true
      this.$emit('doQuery', data.item)
    },
    removeFormatDate(date) {
      if (date === null) {
        return null
      } else if (date === undefined) {
        return null
      } else if (date === '') {
        return null
      } else {
        var dateString = date
        var dateParts = dateString.split('/')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      }
    }
  },
  props: {
    fetchClaim: {
      type: Boolean,
      default: false
    },
    inter: {
      type: String,
      default: ''
    },
    interGroupCode: {
      type: String,
      default: ''
    }
  },
  mixins: [listMixin, MessageMixin]
}
</script>

<style>
</style>
